import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const EmpresaContext = createContext(null);

const STORAGE_KEY = 'kairos_empresa_atual_id';

// Ticket 907: cliente/contador podem estar vinculados a mais de uma empresa
// (grupo economico com o mesmo e-mail em varios CNPJs no CRM). Esse contexto
// guarda qual empresa esta "selecionada" no momento, pra documentos/resumo/
// certificado nao misturarem dados de empresas diferentes.
export function EmpresaProvider({ children }) {
  const { usuario } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [empresaAtual, setEmpresaAtualState] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const multiEmpresa = usuario?.perfil === 'cliente' || usuario?.perfil === 'contador';

  useEffect(() => {
    if (!usuario || !multiEmpresa) {
      setEmpresas([]);
      setEmpresaAtualState(null);
      setCarregando(false);
      return;
    }
    setCarregando(true);
    api.get('/empresas')
      .then(({ data }) => {
        setEmpresas(data);
        const salvoId = localStorage.getItem(STORAGE_KEY);
        const salva = data.find(e => e.id === salvoId);
        setEmpresaAtualState(salva || data[0] || null);
      })
      .catch(() => setEmpresas([]))
      .finally(() => setCarregando(false));
  }, [usuario, multiEmpresa]);

  const setEmpresaAtual = useCallback((empresa) => {
    setEmpresaAtualState(empresa);
    if (empresa) localStorage.setItem(STORAGE_KEY, empresa.id);
  }, []);

  return (
    <EmpresaContext.Provider value={{
      empresas,
      empresaAtual,
      setEmpresaAtual,
      carregando,
      temMultiplasEmpresas: empresas.length > 1,
    }}>
      {children}
    </EmpresaContext.Provider>
  );
}

export const useEmpresa = () => useContext(EmpresaContext);
